import axios from 'axios';
import { useEffect, useState } from 'react';
import { ApiData } from '../types/rest';

export const useData = (url: string) => {
	const [data, setData] = useState<ApiData | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		if (!url) return;

		const controller = new AbortController();

		const fetchData = async () => {
			try {
				setIsLoading(true);
				setError(null);

				// Get country from URL parameters
				const urlParams = new URLSearchParams(window.location.search);
				const country = urlParams.get('country');

				const response = await axios.post<ApiData>(url, country ? { country } : {}, {
					signal: controller.signal,
				});

				setData(response.data);
			} catch (err) {
				if (axios.isCancel(err)) return; // Don't set error for cancelled requests

				setError(err instanceof Error ? err.message : 'An error occurred');
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();

		return () => {
			controller.abort(); // Cleanup: cancel request if component unmounts
		};
	}, [url]);

	return { data, error, isLoadingAppData: isLoading };
};
